// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import SystemSettings from './SystemSettings';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(SystemSettings);
